import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconCreditCardSvg } from "./IconCreditCardSvg.mjs";
const IconCreditCard = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconCreditCardSvg, ...svgProps }) });
export {
  IconCreditCard
};
